module.exports = __webpack_public_path__ + "img/nexultra-3.77cebd88.jpg";